<vb-breadcrumb-one title="FAQ" [disableTitle]="true"></vb-breadcrumb-one>

<section>
    <div class="container-fluid mt-4 mb-4">
        <div>
            <vb-page-header class="mb-2" heading="Frequently Asked Questions">
            </vb-page-header>
            <p class="mb-4">
                Answers to common questions about bidding, pickup, and account management. If your issue is not addressed below, please
                <a [routerLink]="['/contact-us']" class="faq-contact-link"
                    >contact us</a
                >.
            </p>

            <div
                class="faq-section mb-4"
                *ngFor="let section of sections">
                <h3 class="mb-3">{{ section.title }}</h3>
                <div
                    class="accordion"
                    [id]="'faqAccordion-' + section.id">
                    <div
                        class="accordion-item"
                        *ngFor="let faq of section.faqs; let i = index">
                        <h2
                            class="accordion-header"
                            [id]="'faqHeading-' + section.id + '-' + i">
                            <button
                                class="accordion-button"
                                [class.collapsed]="i !== 0"
                                type="button"
                                data-bs-toggle="collapse"
                                [attr.data-bs-target]="
                                    '#faqCollapse-' + section.id + '-' + i
                                "
                                [attr.aria-expanded]="i === 0"
                                [attr.aria-controls]="
                                    'faqCollapse-' + section.id + '-' + i
                                ">
                                {{ faq.question }}
                            </button>
                        </h2>
                        <div
                            [id]="'faqCollapse-' + section.id + '-' + i"
                            class="accordion-collapse collapse"
                            [class.show]="i === 0"
                            [attr.aria-labelledby]="
                                'faqHeading-' + section.id + '-' + i
                            "
                            [attr.data-bs-parent]="'#faqAccordion-' + section.id">
                            <div class="accordion-body">
                                <p *ngFor="let paragraph of getParagraphs(faq.answer)">
                                    {{ paragraph }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
